import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "../css/landingPage.css";
import cst from "../images/partnerLogos/cst.png";
import kenli from "../images/partnerLogos/kenli.png";
import kmc from "../images/partnerLogos/kmc.png";
import maxxis from "../images/partnerLogos/maxxis.png";
import wtb from "../images/partnerLogos/wtb.png";
import schwalbe from "../images/partnerLogos/schwalbe.png";
import neco from "../images/partnerLogos/neco.png";
import ralson from "../images/partnerLogos/ralson.png";
import prowheel from "../images/partnerLogos/prowheel.png";
import sunrace from "../images/partnerLogos/sunrace.png";
import shimano from "../images/partnerLogos/shimano.png";
import sram from "../images/partnerLogos/sram.png";
import rockshox from "../images/partnerLogos/rockshox.png";
import microshift from "../images/partnerLogos/microshift.png";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import Meta from "../components/Meta";
import Modal from "../components/Modal";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";
import ModalMobile from "../components/ModalMobile";
import ReactPlayer from "react-player";
import CustomBike from "../components/CustomBike";
import "../css/navbar.css";
import logo from "../images/brandLogos/Dynem red white.png";
import { Icon } from "@iconify/react";
import ReCAPTCHA from "react-google-recaptcha";
import "../css/landingPage2.css";

const LandingPage2It = () => {
  const [capVal, setCapVal] = useState("");

  const featuresData = [
    {
      key: "precisionControllers",
      heading: "Controller di Precisione",
      description:
        "I controller per e-bike utilizzano sensori intelligenti e algoritmi per fornire potenza in modo fluido, migliorando le prestazioni e rendendo le corse più intuitive. Costruisci in modo più intelligente con i componenti DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Controlerrrr.png",
    },
    {
      key: "highPerformanceChargers",
      heading: "Caricatori ad Alte Prestazioni",
      description:
        "I nostri caricatori sono disponibili in opzioni personalizzabili—progettati per la compatibilità globale, la portabilità semplice e le esigenze di alimentazione flessibili. Potenzia il tuo marchio con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Chargerrrr.png",
    },
    {
      key: "multifunctionalDisplays",
      heading: "Display Multifunzione",
      description:
        "I display LCD multifunzione forniscono statistiche in tempo reale come velocità e livello della batteria, aiutando i ciclisti a mantenere il controllo e a cambiare modalità senza sforzo. Eleva la tecnologia della tua corsa con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Displayyyyy.png",
    },
    {
      key: "longLastingBatteries",
      heading: "Batterie a Lunga Durata",
      description:
        "Le nostre batterie a lunga durata sono progettate per prestazioni costanti, lunga vita utile e un’erogazione ottimale di potenza—alimentando ogni corsa con affidabilità. Dai energia alle tue e-bike con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Baterryyyyy.png",
    },
    {
      key: "efficientMotors",
      heading: "Motori Efficienti",
      description:
        "I nostri motori efficienti offrono prestazioni affidabili e precise in tutte le applicazioni—progettati per la potenza, progettati per uno scopo. Guida la tua innovazione con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/motorrrr.png",
    },
  ];
  const [open, openNav] = useState(false);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, []);

  const closeNavforDeadLink = () => {
    openNav(false);
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [sales, setSales] = useState("");
  const [productPortfolio, setProductPortfolio] = useState("");

  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      alert("Enter Contact Number");
      return;
    }
    const response = await fetch("/api/verify-captcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ capVal }),
    });

    const dataCaptcha = await response.json();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const reqBody = {
      name,
      email,
      phoneNumber,
      companyName,
      enquiry,
      country,
      sales,
      productPortfolio,
    };
    if (dataCaptcha) {
      const { data } = await axios.post(
        "/api/form/request-a-quote",
        reqBody,
        config
      );
      if (data) {
        navigate("/details-submitted");
      }
    } else {
      alert("CAPTCHA Verification Failed!");
    }
  };
  return (
    <>
      <div
        className="position-fixed w-100 d-lg-none"
        style={{ bottom: "1.5%", zIndex: 2 }}
      >
        <div className="d-flex justify-content-center">
          <Link
            to={"/landing-page/form"}
            style={{ width: "85%" }}
            className="btn btn-danger py-2 rounded-5"
          >
            Get in Touch
          </Link>
        </div>
      </div>

      <div id="LandingPage2">
        {/* hero-section */}
        <div className="position-relative">
          <div
            className="position-absolute w-100"
            style={{ top: "2%", zIndex: "1" }}
          >
            <div className="d-lg-block d-none">
              <div className="d-flex justify-content-between align-items-center px-lg-5 mb-5">
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <Link
                  to={"/"}
                  className="btn btn-danger fw-bold px-4 py-2 rounded-5"
                  style={{ backgroundColor: "#ff0000" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Get in Touch
                </Link>
              </div>
              <div>
                <h3 className="poppins-bold mb-3 text-center text-uppercase text-light">
                  Il più grande produttore ed esportatore di bici elettriche del
                  Sud-est asiatico
                </h3>
                <h5 className="text-light text-center poppins-medium">
                  Costruiamo il futuro della mobilità
                </h5>
              </div>
            </div>

            <div className="d-lg-none">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "2em", flexDirection: "column" }}
              >
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <div>
                  <h5 className="poppins-bold mb-3 text-center text-uppercase text-light">
                    Il più grande produttore ed esportatore di bici elettriche
                    del Sud-est asiatico
                  </h5>
                  <p className="text-light text-center poppins-medium">
                    Costruiamo il futuro della mobilità
                  </p>
                </div>
              </div>
            </div>
          </div>
          <video
            className="w-100"
            autoPlay
            loop
            muted
            playsInline
            style={{ height: "100vh", width: "100vw", objectFit: "cover" }}
          >
            <source
              media="(max-width:650px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+page+video+phone+view+.mp4"
              type="video/mp4"
            />
            <source
              media="(min-width:651px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+Page+video+desktop+view+.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div
            className="position-absolute d-lg-block d-none w-100"
            style={{ bottom: "8%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-5"
              style={{ gap: "12em" }}
            >
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">
                  240,000 sq. ft.
                </h4>
                <h5 className="poppins-bold text-light mb-3">Gigafactory</h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">500,000</h4>
                <h5 className="poppins-bold text-light mb-3">
                  Capacità produttiva annuale di e-bike
                </h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">18+</h4>
                <h5 className="poppins-bold text-light mb-3">Paesi</h5>
              </div>
            </div>
          </div>
          <div
            className="position-absolute d-lg-none text-light"
            style={{ bottom: "13%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-3"
              style={{ gap: "0.9em" }}
            >
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  240,000 sq. ft.
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  Gigafactory
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  500,000
                </p>
                <p
                  className="poppins-bold text-light mb-1 w-75 mx-auto"
                  style={{ fontSize: "0.6em" }}
                >
                  Capacità produttiva annuale di e-bike
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  18+
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  Paesi
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* form */}
        <div className="d-none d-lg-block my-5 py-lg-5 container">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Costruiamo la tua prossima grande corsa
          </h2>
          <div className="d-flex justify-content-center mb-4">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Contatta il nostro team di sviluppo aziendale per scoprire come
              DYNEM può dare impulso alla tua visione di ciclo elettrico.
            </h5>
          </div>
          <div className="row p-0">
            <div className="col-6 p-3">
              <h3 className="poppins-medium mb-4">Perché scegliere DYNEM?</h3>
              <div>
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Group+49.jpg"
                  className="img-fluid"
                ></img>
              </div>
            </div>
            <div className="col-6 p-3">
              <form className="" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Nome*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control text-dark"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Telefono*
                    </label>
                    <br></br>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Email*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1 text-light"
                      style={{ fontSize: "0.8em" }}
                      className="form-label"
                    >
                      Azienda*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Operational Countries*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Messaggio*
                  </label>
                  <textarea
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    class="form-control rounded-0"
                    required
                    id="exampleFormControlTextarea1"
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  style={{ backgroundColor: "#ff0000" }}
                  class="btn btn-danger w-100 poppins-medium rounded-5 py-2"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* ebikes */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Dal concetto al tragitto – Il tuo partner OEM per ogni fase
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Che tu stia lanciando un pendolare urbano o una potenza da
              fuoristrada, DYNEM ha la tecnologia, il design e la forza per
              farlo accadere.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Mountain+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">Mountain E-Bikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Non costruiamo solo mountain e-bike, le ingegnerizziamo
                      per l'avventura. Progettate per terreni accidentati, la
                      nostra gamma da fuoristrada offre potenza, controllo e
                      prestazioni impareggiabili. Affronta la natura selvaggia
                      con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Foldable+Fat+tyre.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Folding Fat-Tyred E-Bikes
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Compatti quando ne hai bisogno. Resistenti quando conta.
                      Le nostre e-bike pieghevoli con pneumatici larghi sono
                      progettate per una vita in movimento, perfette per viaggi
                      in città, spostamenti e fughe nel fine settimana. Trova la
                      tua libertà pieghevole con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/City+Bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">City E-Bikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Sfreccia nel traffico con facilità. Le nostre e-bike da
                      città combinano tecnologia all'avanguardia con un design
                      moderno per rendere i tragitti quotidiani facili, comodi e
                      stilosi. Ridefinisci il tuo tragitto urbano con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Delivery+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">Delivery E-Bikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Costruite per il business in movimento. Queste e-bike sono
                      progettate per consegne ad alta capacità con telai
                      resistenti, ampio spazio di carico e prestazioni
                      affidabili, il tutto rimanendo ecologiche. Mantieni le tue
                      operazioni rapide, intelligenti e sostenibili con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        {/* components */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Alimentando il Cuore di Ogni E-Bike
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Che si tratti di un motore ad alta coppia o di un elegante display
              digitale, DYNEM offre precisione, prestazioni e affidabilità per
              alimentare la tua corsa con componenti di qualità.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              {featuresData.map((feature, index) => (
                <SplideSlide className="h-100 p-2">
                  <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                    <div className="text-start col col-md-6 p-lg-3 d-lg-block d-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="ecycle-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                    <div className="col col-md-6">
                      <img src={feature.image} alt="" className="w-75" />
                    </div>
                    <div className="text-start col col-md-6 p-lg-3 d-lg-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="component-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
        {/* breaker */}
        <div className="mt-5 py-lg-5">
          <picture className="">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/phone+anti+Dumping+banner.png.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
              alt="assurance"
              className="d-block img-fluid"
            />
          </picture>
        </div>
        {/* trust section */}
        <div className="container mt-5 py-4 py-lg-5 trust-section-landing-page2">
          <h2 className="poppins-bold mb-2 text-uppercase text-center">
            Perché i Marchi Globali si Affidano a DYNEM
          </h2>
          <h5 className="text-center mb-0 text-muted">
            Il Tuo Prodotto. La Nostra Competenza.
          </h5>
          <div className="mt-5 pt-lg-3">
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/end-to-end.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Partner di Produzione End-to-End
              </h4>
              <div className="col-md-6">
                <small>
                  Dal concetto alla consegna finale, offriamo soluzioni complete
                  OEM e white-label su misura per le esigenze del tuo marchio.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/stae-of-art.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Produzione All'Avanguardia
              </h4>
              <div className="col-md-6">
                <small>
                  Linee di produzione automatizzate e ingegneria di precisione
                  garantiscono qualità costruttiva costante su larga scala,
                  rispettando gli standard internazionali.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/high-performance.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Tecnologia ad Alte Prestazioni
              </h4>
              <div className="col-md-6">
                <small>
                  Integriamo motori potenti, batterie a lunga autonomia e
                  sistemi IoT intelligenti per offrire e-bike progettate per le
                  esigenze della mobilità moderna.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/e-cycles.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Oltre 500.000 E-Bike All'Anno
              </h4>
              <div className="col-md-6">
                <small>
                  La nostra infrastruttura scalabile supporta tutto: da piccoli
                  lotti personalizzati a produzioni globali ad alto volume, con
                  rapidità e precisione.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/components.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Oltre 4 Milioni di Componenti All’Anno
              </h4>
              <div className="col-md-6">
                <small>
                  Con un approvvigionamento ad alta capacità e un’integrazione
                  interna, garantiamo disponibilità, efficienza e qualità per
                  tutti i componenti.
                </small>
              </div>
            </div>
          </div>
        </div>
        {/* company logos */}
        <div className="logos-landing-page2">
          <h3 className="poppins-bold mb-0 text-center text-uppercase">
            Il Nome su cui Contano i Marchi Globali
          </h3>
          <div className="container my-lg-5 pb-5 d-none d-lg-block">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
          <div className="my-5 d-lg-none">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        <div className="my-5 py-lg-5 container">
          <Splide
            className="mb-2 mb-lg-0 p-0 align-items-center text-center"
            options={{
              arrows: true,
              start: 0,
              drag: false,
              type: "loop",
              pagination: true,
              autoplay: true,
              gap: "1em",
              padding: "1em",
              pauseOnHover: false,
              resetProgress: false,
              perPage: 3,
              perMove: 1,
              speed: 1000,
              interval: 4000,
              breakpoints: {
                700: {
                  drag: true,
                  autoplay: false,
                  pagination: "false",
                  perPage: 1,
                  perMove: 1,
                  gap: "2em",
                  padding: "0em",
                  arrows: false,
                  pauseOnHover: false,
                  resetProgress: false,
                },
              },
            }}
          >
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “DYNEM non si è limitata a fornire componenti—ha compreso
                      la nostra visione di prodotto e ci ha aiutati a
                      realizzarla. Il loro team sembra più un’estensione del
                      nostro.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small> – Responsabile Prodotto, Startup di E-Bike</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Siamo passati da 500 a 5.000 unità al mese senza
                      problemi. La coerenza di DYNEM in termini di qualità e
                      tempistiche è stata rivoluzionaria.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – COO, Marchio di Mobilità del Sud-Est Asiatico
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Grazie alle esportazioni conformi alle normative
                      anti-dumping di DYNEM, siamo entrati nel mercato UE con
                      enormi risparmi sui dazi—quasi l’87% di costi in meno.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Direttore Commercio Internazionale, Rivenditore con sede
                      negli USA
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Dai motori ad alta efficienza ai telai resistenti, ogni
                      componente che acquistiamo da DYNEM offre prestazioni e
                      durabilità.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– CTO, Marchio di E-Bike da Avventura</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “La flessibilità nel personalizzare la nostra linea di
                      e-bike pieghevoli è stata davvero incredibile. DYNEM ci ha
                      dato la libertà di creare un prodotto che rispecchia il
                      nostro marchio.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– Product Manager, Marchio di Mobilità Urbana</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Non si limitano a produrre—risolvono problemi. DYNEM ci
                      ha aiutati a riprogettare componenti chiave che hanno
                      effettivamente migliorato le prestazioni di guida.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Responsabile R&D, Etichetta Premium di E-Bike
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
          </Splide>
        </div>
        {/* news */}
        <div className="news">
          <div className="container mt-5 py-4 py-lg-5">
            <h2 className="poppins-bold text-uppercase mb-3 mb-lg-5">
              Nelle notizie
            </h2>
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center"
              options={{
                arrows: false,
                drag: false,
                type: "slide",
                pagination: false,
                autoplay: false,
                perMove: 1,
                gap: "1em",
                padding: "0em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 4,
                speed: 1000,
                interval: 3000,
                breakpoints: {
                  700: {
                    drag: true,
                    perPage: 1.3,
                    arrows: false,
                    perMove: 1,
                    gap: "1em",
                    padding: "0em",
                    pauseOnHover: false,
                    resetProgress: false,
                    focus: 0,
                    start: 0,
                    speed: 1000,
                    interval: 3000,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+1.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/kxan.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM begins construction of World's Biggest Integrated
                    Electric Cycle Gigafactory.....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.kxan.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/ktla.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    India’s DYNEM to Establish World’s Largest Integrated E-Bike
                    Gigafactory
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://fox59.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/benzinga.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Breaks Ground on World’s Largest Integrated Electric
                    Cycle Gigafactory ...
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+4.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/fox8.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Strengthens India’s Manufacturing Prowess: World’s
                    Biggest .....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
            <div className="mt-5 pt-lg-4">
              <h2 className="poppins-medium mb-3 mb-lg-4 container">
                Certifications
              </h2>
              <div className="container pb-4">
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/certifications__png.png"
                  alt="certifications"
                  className="w-100"
                ></img>
              </div>
            </div>
          </div>
        </div>
        {/* FAQs */}
        <div className="container mt-5 pt-lg-5">
          <div className="d-flex faq-landing">
            <div className="faq-landing-1">
              <h2 className="poppins-medium mb-2 mb-lg-4">Domande frequenti</h2>
              <p className="mb-lg-5">
                Hai domande? Abbiamo già le risposte. È come se potessimo
                sentirti pensare.
              </p>
              <div className="d-lg-block d-none">
                <h4 className="poppins-medium mb-2">
                  Ci siamo persi qualcosa?
                </h4>
                <p className="mb-lg-5">
                  Partecipa a una chiamata individuale con i nostri esperti.
                </p>
                <div className="req-call my-5 my-lg-0">
                  <a
                    href="tel:+918956703515"
                    className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                    style={{ width: "fit-content" }}
                  >
                    Richiedi una chiamata
                  </a>
                </div>
              </div>
            </div>
            <div className="accordion faq-landing-2" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Cosa rende DYNEM diverso dagli altri produttori di e-bike?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body poppins-thin">
                    <p>
                      DYNEM si distingue per l'innovazione all'avanguardia, le
                      pratiche ecocompatibili e le ampie opzioni di
                      personalizzazione. La nostra gigafactory all'avanguardia,
                      la conformità globale e il team di esperti garantiscono
                      qualità di prim'ordine e supporto continuo dalla
                      produzione al post-vendita, lasciandoti solo la massima
                      tranquillità.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Posso personalizzare la mia e-bike con DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Assolutamente! DYNEM offre ampie opzioni di
                      personalizzazione, permettendoti di adattare la tua e-bike
                      al tuo stile e alle tue esigenze specifiche. Il nostro
                      servizio OEM ti consente di personalizzare il marchio, le
                      specifiche e le funzionalità in base alle tue preferenze.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Quante e-bike produce DYNEM ogni anno?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DDYNEM ha la capacità di produrre e personalizzare 500.000
                      e-bike all'anno. I nostri efficienti processi produttivi e
                      le nostre infrastrutture di livello mondiale ci consentono
                      di soddisfare la crescente domanda globale.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Quali sono i vantaggi delle soluzioni antidumping di DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Le soluzioni legali antidumping di DYNEM consentono agli
                      importatori di risparmiare fino all'87% sulle tasse. I
                      nostri prodotti sono conformi alle normative globali,
                      garantendo condizioni di parità senza tasse antidumping.
                      Ciò rende DYNEM una scelta conveniente e conforme per gli
                      importatori di tutto il mondo.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    How does DYNEM support sustainability?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      <Link
                        to={"/"}
                        style={{ color: "inherit", cursor: "auto" }}
                        className="text-decoration-none"
                      >
                        DYNEM
                      </Link>
                      è impegnata nella sostenibilità attraverso pratiche
                      ecocompatibili e tecnologie innovative. Le nostre e-bike
                      sono progettate per ridurre le emissioni di carbonio e
                      promuovere un futuro più verde, in linea con la nostra
                      visione di mobilità sostenibile.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    Che tipo di supporto post-vendita fornisce DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM dà priorità alla soddisfazione del cliente con un
                      supporto post-vendita dedicato. Dall'acquisto iniziale
                      alla manutenzione a lungo termine, il nostro team si
                      impegna a fornire un'assistenza continua e affidabile,
                      garantendo un'esperienza fluida e soddisfacente per i
                      nostri clienti.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-lg-none text-center mt-3">
              <h4 className="poppins-medium mb-2">Ci siamo persi qualcosa?</h4>
              <p className="mb-lg-5">
                Partecipa a una chiamata individuale con i nostri esperti.
              </p>
              <div className="req-call my-4">
                <a
                  href="tel:+918956703515"
                  className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                  style={{ width: "fit-content" }}
                >
                  Richiedi una chiamata
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="d-lg-block d-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <Modal className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        <div className="d-lg-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <ModalMobile className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        {/* contact us */}
        <div className="mt-5 py-lg-5" style={{ backgroundColor: "black" }}>
          <div className="container py-lg-5 py-4">
            <div className="d-flex mb-3 mb-lg-0" style={{ gap: "4em" }}>
              <div className="d-none d-lg-block w-50">
                <div className="row">
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                  </div>
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-start mt-5">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-start">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block">
                <h2 className="poppins-bold mb-4 text-light">Connettiamoci</h2>
                <form className="contact-us-landing" onSubmit={submit}>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-100">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Nome*
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div class="w-50">
                      <label
                        for="exampleInputPassword1"
                        class="form-label text-light"
                      >
                        Telefono*
                      </label>
                      <IntlTelInput
                        onChangeNumber={setPhoneNumber}
                        initOptions={{
                          initialCountry: "auto",
                          geoIpLookup: function (success, failure) {
                            fetch("https://ipapi.co/json")
                              .then((res) => res.json())
                              .then((data) => success(data.country_code))
                              .catch(() => failure());
                          },
                          strictMode: true,
                          separateDialCode: true,
                        }}
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Work Email*
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1 text-light"
                        className="form-label text-light"
                      >
                        Azienda*
                      </label>
                      <input
                        type="text"
                        value={companyName}
                        required
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Product Portfolio*
                      </label>
                      <select
                        onChange={(e) => setProductPortfolio(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="E-Bikes">E-Bikes</option>
                        <option value="E-Scooters">E-Scooters</option>
                        <option value="Hyper-Bikes">Hyper-Bikes</option>
                        <option value="Moped">Moped</option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Operational Countries*
                      </label>
                      <input
                        type="text"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Annual E-Bike Sales (units)
                      </label>
                      <select
                        onChange={(e) => setSales(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="less than 1000 units">
                          less than 1000 units
                        </option>
                        <option value="1000-5000 units">1000-5000 units</option>
                        <option value="5000-50,000 units">
                          5000-50,000 units
                        </option>
                        <option value="50,000+ units">50,000+ units</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Messaggio*
                    </label>
                    <textarea
                      class="form-control rounded-0"
                      required
                      id="exampleFormControlTextarea1"
                      rows="3"
                      value={enquiry}
                      onChange={(e) => {
                        setEnquiry(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  <div className="mb-3 d-flex justify-content-center">
                    <ReCAPTCHA
                      sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                      onChange={(val) => setCapVal(val)}
                    ></ReCAPTCHA>
                  </div>
                  <button
                    disabled={!capVal}
                    type="submit"
                    class="btn btn-light w-100 poppins-medium rounded-0"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
            <div className="d-lg-none mb-5">
              <h2 className="poppins-bold mb-4 text-light">Connettiamoci</h2>
              <form className="contact-us-landing" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Nome*
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label text-light"
                    >
                      Telefono*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Work Email*
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-2"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Azienda*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Operational Countries*
                    </label>
                    <input
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label text-light"
                  >
                    Messaggio*
                  </label>
                  <textarea
                    class="form-control rounded-0"
                    id="exampleFormControlTextarea1"
                    required
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  class="btn btn-light w-100 poppins-medium rounded-0"
                >
                  Submit
                </button>
              </form>
            </div>
            <div className="row p-2 d-lg-none">
              <div className="col-6 p-0">
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                    className="w-75 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
              </div>
              <div className="col-6 p-0">
                <div className="d-flex justify-content-start mt-5">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-start">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                    className="w-75 p-2"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage2It;
